<section class="reset-password-page">
  <form *ngIf="form" class="reset-password-form" [formGroup]="form" (ngSubmit)="submitReset()">
    <p class="h1 fw-light" data-test-id="reset-password-form-title">
      {{ 'RESET_PASSWORD_TEXT' | translate }}
    </p>
    <div class="mb-3" data-test-id="wrap-reset-password-form-email">
      <label class="form-label" for="email" data-test-id="email-label">
        {{ 'LOGIN_FORM_EMAIL_LABEL' | translate }} *
      </label>
      <input
        class="form-control"
        [ngClass]="{ 'is-invalid': isFieldInvalid('email') }"
        type="email"
        formControlName="email"
        id="email"
        data-test-id="reset-password-form-email"
        placeholder="{{ 'FORM_EMAIL_INPUT_PLACEHOLDER' | translate }}"
      />
      <small class="invalid-feedback" data-test-id="reset-password-form-email-error">
        {{ getErrorDescriptionId('email') | translate }}
      </small>
      <small class="form-text text-muted mt-3"> * - {{ 'REQUIRED_FIELD_HINT' | translate }} </small>
    </div>
    <div class="submit-button">
      <button
        appLongOperation
        class="btn btn-primary text-white"
        type="submit"
        data-test-id="reset-password-form-reset-btn"
      >
        {{ 'RESET_BTN_HINT' | translate }}
      </button>
    </div>
  </form>
</section>
